import moment from 'moment/min/moment-with-locales';

export const buildGraphPayload = (controls) => {
  if (!controls) return '';
  const payload = `?start_dt=${moment(controls.dates.start_dt).format('YYYY-MM-01')}&end_dt=${moment(
    controls.dates.end_dt
  ).format('YYYY-MM-28')}&types=${controls.residencyTypeList.join(',')}`;
  return payload;
};
